import Color from 'color';

export const areSameColor = (colorA, colorB) => colorA === colorB;

export const getColor = (value, defaultColor) => {
  const finalValue =
    value &&
    typeof value === 'string' &&
    !(value.includes('#') || value.includes('rgb'))
      ? `#${value}`
      : value;

  try {
    return Color(finalValue);
  } catch {
    return Color(defaultColor);
  }
};

export const getInputColor = (color) =>
  color === 'transparent' ? '' : getColor(color).hex().replace('#', '');
